import { ENDPOINT } from 'api/endPoints/getCardMatrixCountersData';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemWithCustomProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { LARGE } from 'components/Dashboards/Reporting/reportingConfig';
import { Props as PrioritiesMatrixProps } from 'components/widgets/PrioritiesMatrix/prioritiesMatrix';

export const prioritiesMatrix: IHashmapItemWithCustomProps<PrioritiesMatrixProps> = {
    NoPermissionMessage,
    title: 'Priorities Matrix',
    componentKey: 'prioritiesMatrix',
    id: 'prioritiesMatrix',
    globalFiltersConfig: [
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'wbs', name: 'wbs', defaultValue: null },
    ],
    reportStyle: {
        widgetSizesAvailable: { large: LARGE },
        widgetInitialSize: LARGE,
    },
    endpoint: ENDPOINT,
};
